import type angular from 'angular';
import type { Unit } from '../types';

import { type FavoriteUnitRef, unitApi } from '../services/api';
import { workspaceFavoritesReady } from '../unit-favorite-btn/unitFavoriteBtn.controller';

svgUnitCtrl.$inject = ['$state', '$scope'];

interface SvgUnitCtrlProps {
  state: any;
  publicMode: boolean;
  unit: Unit;
  statusClass: string;
  isFavorited: boolean;
}

export function svgUnitCtrl(
  this: SvgUnitCtrlProps,
  $state,
  $scope: angular.IScope,
) {
  const vm = this;

  vm.state = $state;
  vm.isFavorited = false;

  workspaceFavoritesReady.then((units) => {
    if (!units.length) {
      return;
    }

    vm.isFavorited = units.some(({ id }) => id === vm.unit.unit_id);

    $scope.$apply();
  });

  $scope.$on(
    'favoriteUnitsUpdated',
    (_e: unknown, { units }: { units: FavoriteUnitRef[] }) => {
      vm.isFavorited = units.some(({ id }) => id === vm.unit.unit_id);
    },
  );

  switch (vm.unit.status.type) {
    case unitApi.STATUS_TYPE.CLOSED:
      vm.statusClass = vm.publicMode ? 'sold' : 'closed';
      break;
    case unitApi.STATUS_TYPE.AVAILABLE:
      vm.statusClass = 'free';
      break;
    case unitApi.STATUS_TYPE.BOOKED:
      vm.statusClass = 'reserved';
      break;
    case unitApi.STATUS_TYPE.SOLD:
      vm.statusClass = 'sold';

      if (Number(vm.unit.is_in_resale)) {
        vm.statusClass = vm.publicMode ? 'free' : 'resale';
      }

      break;
    default:
      vm.statusClass = 'closed';
      break;
  }
}
